import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PILLARS } from "@/data/pillars";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

export const PillarsSection = () => (
  <section className="section bg-mist/60" data-testid="pillars-section">
    <div className="container-x">
      <SectionHead eyebrow="Capabilities" title="Four ways ANFORD works for your portfolio." />
      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:mt-14 lg:grid-cols-4 lg:gap-6">
        {PILLARS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.07}>
            <Link to={`/platform#${p.id}`} data-testid={`pillar-card-${p.id}`} className="group flex h-full flex-col rounded-2xl border border-navy/10 bg-white p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-lg md:p-7">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-gold-soft transition-colors duration-300 group-hover:bg-gold group-hover:text-white">
                <p.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-6 font-display text-lg font-extrabold uppercase tracking-wide text-navy-ink">{p.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate2">{p.summary}</p>
            </Link>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-10">
        <Link to="/platform" data-testid="pillars-explore-link" className="btn-secondary w-full sm:w-auto">
          Explore the ANFORD Platform <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </div>
  </section>
);
